import * as React from "react"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgSearchSm } from "@digits-shared/components/SVGIcons/line/SearchSm.svg"
import { DigitsButton } from "@digits-shared/DesignSystem/Button"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { BrowserDisplayOptions } from "src/frontend/components/OS/Applications/Shared/Transactions/Browser/Filters/BrowserDisplayOptions"
import { useTransactionsDisplayOptions } from "src/frontend/components/OS/Shared/DisplayOptions/TransactionsDisplayOptionsContext"
import { TextFilterInput } from "src/shared/components/Filters/TextFilterInput"

/*
  STYLES
*/

const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 16px 16px 0 0;
  border-bottom: 1px solid ${colors.secondary10};
  background: ${colors.white};
`

const Right = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 4px 0;
`

const Container = styled.div`
  border-radius: 24px;
  flex: 1;
  background: ${colors.translucentSecondary05};
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  flex-shrink: 0;
`

const SearchIcon = styled(SvgSearchSm)`
  height: 18px;
  width: 18px;
  ${svgPathStyles(colors.secondary50, 1.5)};
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

/*
  COMPONENTS
*/

export const BrowserFiltersBar: React.FC = () => {
  const { filterTerm } = useTransactionsDisplayOptions()

  return (
    <HeaderWrapper>
      <Container>
        <SearchIcon />

        <TextFilterInput
          filterTerm={filterTerm.get()}
          setFilterTerm={filterTerm.set}
          placeholder="Filter transactions…"
        />

        <ButtonGroup>
          {!!filterTerm.get() && (
            <DigitsButton $variant="ghost-dark" size="small" onClick={filterTerm.clear}>
              Clear
            </DigitsButton>
          )}
        </ButtonGroup>
      </Container>

      <Right>
        <BrowserDisplayOptions />
      </Right>
    </HeaderWrapper>
  )
}
